export const getRoutePath = (route: string, params = {}) => {
  const entries = Object.entries(params);
  let path = route;
  for (const [key, value] of entries) {
    path = path.replace(`:${key}`, value as string);
  }
  return path;
};
